import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {
    getOptionsByCommaString, isEmpty
} from "../../../../../_helpers/commonFunctions";
import EditableTable from "../../../../primer/Editable-Table";
import {Col, Row} from "react-bootstrap";
import {toast} from "react-toastify";
import DateBox from "../../../../primer/DateBox";
import Dropdown from "../../../../primer/Dropdown";
import {setSaveEditClient} from "../../../../../_reducers/activitySlice";
import {
    resetNewCommunicationHistory,
    setEditClient,
    setNewCommunicationHistory,
    setAiCommunicationHistory,
} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import moment from "moment";
import useTaggedDispatch from "../../../../../hooks/useTaggedDispatch";
import axios from "axios";
import AICallAnalysisModal from "../../CRM/AICallAnalysisModal";
import {useTranslation} from "../../../../../hooks/useTranslation";
import Input from "../../../../common/Input";

const EditClientCommunicationHistory = ({tabKey}) => {
    const {t} = useTranslation();
    const dispatch = useTaggedDispatch({tabKey});
    const ACTIVITY = useSelector((state) => state.ACTIVITY);
    const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const isPrimerOrEmron = company.vatNumber === "800566476" || company.vatNumber === "800434990";
    const editClient = useSelector((state) => state.CLIENTS_DATA.editClient[tabKey]);
    const subjectsOptions = getOptionsByCommaString(CLIENTS_DATA.clientsSettings.clientCommunicationHistory);

    const aiCommunicationHistory = useSelector((state) => state.CLIENTS_DATA.aiCommunicationHistory[tabKey]) || [];
    const communicationHistoryFilters = editClient?.communicationHistoryFilters || {};

    const [incrKey, setIncrKey] = useState(0);

    const [aiLoading, setAiLoading] = useState(false);
    const [aiCallTranscription, setAICallTranscription] = useState(null);
    const [aiAnalysisDate, setAiAnalysisDate] = useState(null);
    const [aiCost, setAiCost] = useState(null);
    const [selectedCall, setSelectedCall] = useState(null);

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [editClient?.communicationHistory])

    useEffect(() => {
        if (!isPrimerOrEmron || !editClient) return;

        const clientPhones = [];
        if (editClient.phone) {
            clientPhones.push(String(editClient.phone).replace(/[^0-9]/g, ""));
        }

        if (Array.isArray(editClient.contactPoints)) {
            editClient.contactPoints.forEach(cp => {
                if (cp.mobile) clientPhones.push(String(cp.mobile).replace(/[^0-9]/g, ""));
                if (cp.landline) clientPhones.push(String(cp.landline).replace(/[^0-9]/g, ""));
            });
        }

        const uniquePhones = [...new Set(clientPhones.filter(p => p !== ""))];
        if (uniquePhones.length > 0) {
            axios.post(`${process.env.REACT_APP_API_URL2}/ai/get-client-calls`, {
                phones: uniquePhones,
                companyVatNumber: company.vatNumber
            })
                .then(res => {
                    if (res.data?.status === "200" && res.data?.data) {
                        const formattedAiCalls = res.data.data.map((call, index) => {
                            const callDate = moment(call.calldate);
                            return {
                                id: `ai_${call._id}`,
                                no: `AI-${index + 1}`,
                                isAi: true,
                                date: callDate.format("YYYY-MM-DD"),
                                time: callDate.format("HH:mm"),
                                subject: call.aiJSONResponse?.mainSubject || "AI Κλήση",
                                details: call.aiJSONResponse?.summary || "Δεν υπάρχει περίληψη.",
                                originalAiData: call,
                                agent: call.agent || "",
                            };
                        });
                        dispatch(setAiCommunicationHistory(formattedAiCalls));
                        setIncrKey(prev => prev + 1);
                    }
                })
                .catch(err => console.error("Failed to fetch AI calls", err));
        }
    }, [
        editClient?.phone,
        JSON.stringify(editClient?.contactPoints),
        company.vatNumber
    ]);

    const chColumns = [
        {
            name: "Αρ.",
            field: "no",
            width: "35px",
            editable: false,
        },
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.date'),
            field: "date",
            width: "80px",
            editable: true,
            inputType: { type: 'datebox' }
        },
        {
            name: "Ώρα",
            field: "time",
            width: "50px",
            editable: true,
            inputType: { type: 'time' }
        },
        company.vatNumber === "800566476" ? {
            name: "Εργαζόμενος",
            field: "agent",
            width: "110px",
            editable: false,
        } : null,
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.subject'),
            field: "subject",
            width: "100px",
            editable: true,
            inputType: {
                type: 'dropdown',
                options: subjectsOptions
            }
        },
        {
            name: t('ClientsNewCommunicationHistoryEdit.table1.details'),
            field: "details",
            editable: true,
            width: "400px",
            inputType: { type: 'textarea' }
        },
    ].filter(Boolean);

    const handleOnFilterChange = (e, type = "default", ddname = '') => {
        const prepFilters = {...communicationHistoryFilters};

        let name;
        let value;
        if (type === "msdd") {
            name = ddname;
            value = e.flatMap((o) => o.value);
        } else if (type === "dd") {
            name = ddname;
            value = e.value;
        } else if (type === "dp") {
            value = e;
            name = ddname;
        } else {
            name = e.target.name;
            value = e.target.value;
        }
        prepFilters[name] = value;

        dispatch(setEditClient({...editClient, communicationHistoryFilters: prepFilters}));
        setIncrKey(incrKey + 1);
    }

    const tableActions = {
        insert: (e, data) => {
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            const tempCommunicationHistory = {...CLIENTS_DATA.newCommunicationHistory};
            tempCommunicationHistory[data.field] = data.value;
            dispatch(setNewCommunicationHistory(tempCommunicationHistory));
            if (tempCommunicationHistory && !isEmpty(tempCommunicationHistory.subject) && !isEmpty(tempCommunicationHistory.details) && tempCommunicationHistory.date && tempCommunicationHistory.time) {
                const cloneIt = structuredClone([tempCommunicationHistory, ...structuredClone(editClient?.communicationHistory || [])]);
                cloneIt.forEach((row, idx) => {
                    row.id = idx + 1;
                    row.no = idx + 1;
                })
                dispatch(setEditClient({...editClient, communicationHistory: cloneIt}));
                dispatch(resetNewCommunicationHistory());
            }
        },
        update: (data, id) => {
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));

            if (data.date && (data.date === "")) {
                toast.error("Date is mandatory field.");
            } else if (data.time && (data.time === "")) {
                toast.error("Time is mandatory field.");
            } else {
                const cloneIt = editClient.communicationHistory.slice();
                const rowIndex = cloneIt.findIndex((el) => String(el.no) === String(id));
                if (rowIndex >= 0) {
                    cloneIt[rowIndex] = {...cloneIt[rowIndex], ...data};
                    dispatch(setEditClient({...editClient, communicationHistory: cloneIt}));
                }
            }
        },
        selected: (data, rowIndex) => {
            if (data?.isAi) {
                const aiData = data.originalAiData;
                setAICallTranscription(aiData.aiJSONResponse);
                setAiAnalysisDate(aiData.created_at);
                setAiCost(aiData.cost || null);
                setSelectedCall(aiData);
                setAiLoading(false);
            }
        },
        delete: (id, rowIndex, rowData) => {
            if (!ACTIVITY.saveEditClient) dispatch(setSaveEditClient(true));
            const cloneIt = structuredClone(editClient.communicationHistory);
            const idx = cloneIt.findIndex((el) => String(el.no) === String(rowData.no));
            if (idx >= 0) {
                cloneIt.splice(idx, 1);
                cloneIt.forEach((row, idx) => {
                    row.id = idx + 1;
                    row.no = idx + 1;
                });
                dispatch(setEditClient({...editClient, communicationHistory: cloneIt}));
            }
        },
        showAiAnalysis: (id, rowIndex, rowData) => {
            const aiData = rowData.originalAiData;
            setAICallTranscription(aiData.aiJSONResponse);
            setAiAnalysisDate(aiData.created_at);
            setAiCost(aiData.cost || null);
            setSelectedCall(aiData);
            setAiLoading(false);
        }
    }

    const handleRowClick = (e, rowData) => {
        if (rowData?.isAi) {
            const aiData = rowData.originalAiData;
            setAICallTranscription(aiData.aiJSONResponse);
            setAiAnalysisDate(aiData.created_at);
            setAiCost(aiData.cost || null);
            setSelectedCall(aiData);
            setAiLoading(false);
        }
    }

    const getDisplayData = () => {
        let data = [
            ...(editClient?.communicationHistory || []),
            ...(isPrimerOrEmron ? aiCommunicationHistory : [])
        ];

        const dateFormats = ["DD-MM-YYYY HH:mm", "DD/MM/YYYY HH:mm", "YYYY-MM-DD HH:mm"];

        data.sort((a, b) => {
            const dateA = moment(`${a.date} ${a.time}`, dateFormats);
            const dateB = moment(`${b.date} ${b.time}`, dateFormats);
            return dateB.valueOf() - dateA.valueOf();
        });

        const filterDateFormats = ["DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD"];

        if (communicationHistoryFilters?.dateFrom) {
            data = data.filter((el) => moment(el.date, filterDateFormats) >= moment(communicationHistoryFilters.dateFrom));
        }
        if (communicationHistoryFilters?.dateTo) {
            data = data.filter((el) => moment(el.date, filterDateFormats) <= moment(communicationHistoryFilters.dateTo));
        }
        if (communicationHistoryFilters?.subject?.length > 0) {
            data = data.filter((el) => el.isAi || communicationHistoryFilters.subject.includes(el.subject));
        }
        if (communicationHistoryFilters?.generalFilter) {
            const gf = String(communicationHistoryFilters?.generalFilter).toLowerCase();
            data = data.filter((el) => String(el.subject).toLowerCase().includes(gf)
                || String(el.details).toLowerCase().includes(gf)
                || String(el.agent).toLowerCase().includes(gf));
        }

        return data;
    }

    return (
        <div>
            <Row>
                <Col md={2}>
                    <DateBox
                        name="dateFrom"
                        selected={communicationHistoryFilters?.dateFrom}
                        allowOtherYears={true}
                        label={t('ClientsNewCommunicationHistoryEdit.dateFrom')}
                        onChange={(date) => handleOnFilterChange(date, 'dp', 'dateFrom')}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="dateTo"
                        selected={communicationHistoryFilters?.dateTo}
                        allowOtherYears={true}
                        label={t('ClientsNewCommunicationHistoryEdit.dateTo')}
                        onChange={(date) => handleOnFilterChange(date, 'dp', 'dateTo')}
                    />
                </Col>
                <Col md={3}>
                    <Dropdown
                        multiSelect={true}
                        label={t('ClientsNewCommunicationHistoryEdit.subject')}
                        name="subject"
                        options={subjectsOptions}
                        key={communicationHistoryFilters.subject}
                        defaultValue={subjectsOptions.filter((el) => communicationHistoryFilters?.subject?.includes(el.value))}
                        onChange={(e) => handleOnFilterChange(e, 'msdd', 'subject')}
                    />
                </Col>
                <Col md={5}>
                    <Input
                        name={"generalFilter"}
                        label={"Γενικό φίλτρο"}
                        defaultValue={communicationHistoryFilters?.generalFilter}
                        onBlur={(e) => handleOnFilterChange(e, 'input', 'generalFilter')}
                        onKeyDown={(e) => {
                            if (e?.key === "Enter") handleOnFilterChange(e, 'input', 'generalFilter')
                        }}
                    />
                </Col>
            </Row>
            <EditableTable
                className="client-communication-history"
                tableName="Client Communication History"
                allowActions={true}
                key={incrKey}
                actionButtons={{
                    edit: false,
                    print: false,
                    export: false,
                    delete: true,
                }}
                allowFilter={false}
                allowBulkActions={false}
                allowPrintResults={false}
                columns={chColumns}
                allowInsertRowFromTop={true}
                allowFilterTable={false}
                data={getDisplayData()}
                onUpdate={tableActions}
                enableNewRowCheckbox={true}
                onRowClick={handleRowClick}
            />
            <AICallAnalysisModal
                show={aiLoading || aiCallTranscription !== null}
                onHide={() => {
                    setAiLoading(false);
                    setAICallTranscription(null);
                    setAiAnalysisDate(null);
                    setAiCost(null);
                    setSelectedCall(null);
                }}
                data={aiCallTranscription}
                analysisDate={aiAnalysisDate}
                cost={aiCost}
                isLoading={aiLoading}
                row={selectedCall}
            />
        </div>
    )
}

export default EditClientCommunicationHistory;
